// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// DatePicker
import DayPickerInput from "react-day-picker/DayPickerInput";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";

// i18n
import { withNamespaces } from "react-i18next";
// moment
import moment from "moment";

class DateInput extends Component {
  getInputState() {
    const { t } = this.props;

    const {
      meta: { touched, valid },
      errorMessage
    } = this.props;
    const invalidInput = {
      hasError: true,
      style: {
        borderColor: "#A90329"
      }
    };
    const validInput = {
      hasError: false,
      style: {
        borderColor: "#7DC27D"
      }
    };
    const neutralInput = { hasError: false, style: {} };

    return touched
      ? valid
        ? { ...validInput }
        : {
            ...invalidInput,
            errorMessage:
              errorMessage ||
              t("modules.localization.register.authenticated.error.invalidFields.default")
          }
      : neutralInput;
  }

  render() {
    const { disableDays, iconClass, input, label, style, toolTip } = this.props;
    const inputState = this.getInputState();
    const language = moment.locale();

    return (
      <section>
        {label && <label className="label">{label}</label>}
        <label className="input">
          <i className={iconClass} />
          <DayPickerInput
            dayPickerProps={{
              disabledDays: disableDays,
              localeUtils: MomentLocaleUtils,
              locale: language
            }}
            format="L"
            formatDate={formatDate}
            inputProps={{
              autoComplete: "off",
              style: { ...style, ...inputState.style },
              ...input
            }}
            onDayChange={(date) => input.onChange(formatDate(date, "L", language))}
            parseDate={parseDate}
            value={input.value}
          />
          {toolTip && (
            <b className="tooltip tooltip-top-right">
              <i className="fa fa-user txt-color-teal" />
              {toolTip}
            </b>
          )}
          <em className="invalid" style={{ height: 30, minHeight: 30 }}>
            {inputState.hasError && inputState.errorMessage}
            &nbsp;
          </em>
        </label>
      </section>
    );
  }
}

DateInput.propTypes = {
  disableDays: PropTypes.object,
  errorMessage: PropTypes.string,
  iconClass: PropTypes.string,
  label: PropTypes.string,
  toolTip: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.string
};

export default withNamespaces()(DateInput);
